import orderBy from 'lodash/orderBy';
import reduce from 'lodash/reduce';

import * as actions from 'actions/planIntegrationLogs';

const defaultState = {
  data: null,
  logFiles: {},
  next: [],
  status: 'NOT_LOADED',
};

const getData = payload =>
  orderBy(
    reduce(payload, (arr, val) => arr.concat(val.data), []),
    ['completed'],
    ['desc'],
  );

const getNext = payload =>
  reduce(
    payload,
    (arr, val) => {
      if (!val.links.next) {
        return arr;
      }
      return arr.concat(val.links.next);
    },
    [],
  );

const getTotalItems = arr => reduce(arr, (sum, val) => sum + val.total, 0);

export default function planIntegrationLogs(state = defaultState, action) {
  switch (action.type) {
    case actions.GETMANY_START: {
      return {
        ...state,
        status: 'LOADING',
      };
    }
    case actions.GETMANY_SUCCESS: {
      return {
        ...state,
        data: getData(action.payload),
        total: getTotalItems(action.payload),
        next: getNext(action.payload),
        status: 'LOADED',
      };
    }
    case actions.NEXT_START: {
      return {
        ...state,
        next: [],
      };
    }
    case actions.NEXT_SUCCESS: {
      return {
        ...state,
        data: state.data.concat(getData(action.payload)),
        total: getTotalItems(action.payload),
        next: getNext(action.payload),
      };
    }
    case actions.CLEAR: {
      return defaultState;
    }
    case actions.GET_LOGFILE_START: {
      return {
        ...state,
        logFiles: {
          ...state.logFiles,
          [action.payload.logId]: {
            status: 'LOADING',
          },
        },
      };
    }
    case actions.GET_LOGFILE_SUCCESS: {
      return {
        ...state,
        logFiles: {
          ...state.logFiles,
          [action.payload.logId]: {
            status: 'LOADED',
            text: action.payload.text,
          },
        },
      };
    }
    case actions.GET_LOGFILE_FAIL: {
      return {
        ...state,
        logFiles: {
          ...state.logFiles,
          [action.payload.logId]: {
            status: 'ERROR',
          },
        },
      };
    }
    default:
      return state;
  }
}
